export const generateCorrelationId = () => {
    return `instore-portal-${crypto.randomUUID()}`;
}